import styled from 'styled-components';
import { Typography } from '@mui/material';

const Wrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.gray5};
  background: ${({ theme }) => theme.palette.common.white};
  padding: 16px;
`;

const Exception = styled(Typography)`
  border: 1px solid ${({ theme }) => theme.palette.common.red2};
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.common.red10};
  color: ${({ theme }) => theme.palette.common.red2};
  padding: 12px 16px;
  line-height: normal;
  word-break: break-all;
`;

type Props = {
  exception: string | undefined;
};

const ExceptionCard = ({ exception }: Props) => (
  <Wrapper>
    <Exception>{exception}</Exception>
  </Wrapper>
);

export default ExceptionCard;
